module.exports = __webpack_public_path__ + "img/logoutIcon.a25ab39c.svg";